import { combineReducers } from 'redux';
import dev from './dev';
import myStorages from './myStorages';
import auth from './auth';
import subscription from './subscription';
import user from './user';
import address from './address';
import master from './master';
import request from './request';
import courier from './courier';
import box from './box';
import market from './market';
import admin from './admin';
import customer from './customer';
import transaction from './transaction';
import dashboard from './dashboard';
import notification from './notification';

export default combineReducers({
  dev,
  myStorages,
  auth,
  subscription,
  user,
  address,
  master,
  request,
  courier,
  box,
  market,
  admin,
  customer,
  transaction,
  dashboard,
  notification,
});
